import { Device } from "@/api/baseDefine";

export class DeviceControlUtils {
    private deviceList: Device[] = [];
    private selectDeviceId: string = ""
    public setDeviceList(deviceList: Device[]) {
        this.deviceList = deviceList
    }

    public onSelectDeviceId(deviceId: string) {
        this.selectDeviceId = deviceId
    }

    public getSelectDevice(): Device {
        let selectDevice: Device = <Device>{};
        let ss = this.selectDeviceId.split('-')
        let deviceId = ss[0]
        let cls = ss[1]
        console.log(deviceId)
        console.log(cls)
        console.log(this.deviceList)
        for (let i = 0; i < this.deviceList.length; i++) {
            if (this.deviceList[i].deviceId == deviceId && this.deviceList[i].class == cls) {
                selectDevice = this.deviceList[i];
                break;
            }
        }
        return selectDevice;
    }

}